/**
 * @file
 * Trigger button scripts.
 */

const $triggerButton = $('.cpl-trigger', context);

$triggerButton.once('trigger-button').each((index, el) => {
  const $this = $(el);

  // Prevent open url after the popup has started.
  const $triggerLink = $this.find('.cpl-trigger-link');

  if ($triggerLink.attr('data-open')) {
    $triggerLink.click(event => {
      event.preventDefault();
    });
  }
});
